import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserMenuComponent } from './user-menu.component';
import { MatRippleModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { UtclubChangeUserDialogComponent } from 'src/app/components/utclub-change-user-dialog/utclub-change-user-dialog.component';


@NgModule({
  declarations: [
    UserMenuComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatRippleModule,
    RouterModule,
    MatIconModule,
    UtclubChangeUserDialogComponent
  ]
})
export class UserMenuModule {
}
